import React from 'react'
import { useEffect } from 'react';
import { useState } from "react";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { useUpdateGstHsnCodeMutation, useGetGstHsnCodeDetailQuery } from '../../../../store/api/gsthsn';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Tab2 from './Tab2';
import Attachment from '../../../../utils/Attachment';
function Gsthsn() {
    const navigate = useNavigate()
    const location = useLocation()
    const gsthsnId = location?.state.taxId
    const [tab, settab] = useState(1)
    const [taxes, setTaxes] = useState([]);
    const [selectedtaxes, setSelectedtaxes] = useState([])
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [updateGstHsnCode] = useUpdateGstHsnCodeMutation();
    const { data: gstDetail } = useGetGstHsnCodeDetailQuery(gsthsnId);
    const [formdata, setformdata] = useState({ hsncode: '', description: '' })
    const handlechange = (e) => {
        const { name, value } = e.target
        setformdata((prev) => ({
            ...prev,
            [name]: value
        }))

    }
    useEffect(() => {
        if (gstDetail?.data) {
            const { hsn_code, description } = gstDetail.data
            setformdata({
                hsncode: hsn_code || "",
                description: description || ""
            })
            setSelectedtaxes(gstDetail.data.taxes)
        }

    }, [gstDetail])

    const handleSubmit = async () => {

        const payload = { hsn_code: formdata.hsncode, description: formdata.description, taxes: taxes };
        try {
            const res = await updateGstHsnCode({ id: gsthsnId, body: payload });
            setError('GST HSN Code updated successfully!');
            setptype('Success');
            setShowError(true);
            setTimeout(() => {
                navigate('/master/gsthsncode/gst-hsn-list')
            }, 3000);
        } catch (error) {
            const parsedMessages = JSON.parse(error.data._server_messages);
            const firstMessageObj = JSON.parse(parsedMessages[0]);
            console.log(firstMessageObj, "errr");
            setError(firstMessageObj.message);
            setptype('Error');
            setptype('Error');
            setShowError(true);
        }
    };
    return (
        <>
            <FormLayout
                title="Edit GST HSN Code"
                breadcrumbs={[
                    { label: "GST HSN Code" },
                    { label: "GST HSN Code List", url: "/master/gsthsncode/gst-hsn-list" }
                ]}
                status={'hide'}
                actionButtons={
                    <>

                        <Button
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            onClick={handleSubmit}
                            iconSize={12}
                        >Update
                        </Button>
                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                                        General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                            {/* <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                                <span style={{ position: 'relative', top: '-1px' }}>
                                    <GetIcon iconName="CgAttachment" size={12} />
                                </span>
                                <span className=" fw-semibold" style={{ color: "#391F84" }}>
                                    Attachments
                                </span>
                            </div> */}
                         <Attachment doctype="GST HSN Code"  docname={gsthsnId}  />    
                        </div>
                    </div>
                    <div className="mt-2 py-2" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                        <div className="row d-flex justify-content-between">
                            <div className="col-12" >
                                <div className="sidebarbox m-0 px-4 py-2">
                                    <Tab1 setformdata={setformdata} formdata={formdata} handlechange={handlechange} />
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-between">
                            <div className="col-12" >
                                <div className="sidebarbox m-0 px-4 py-2">
                                    <Tab2 setTaxes={setTaxes} taxes={taxes} gsthsnId={gsthsnId} selectedtaxes={selectedtaxes} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayout>
        </>
    )
}

export default Gsthsn
